import logger from '@/modules/Logger';

export default {
  // enable/disable screen share
  async shareScreen(mode) {
    this.constraints.video = !mode;
    this.constraints.screen = mode;

    try {
      this.filterVideoTrack();

      if (mode) {
        // moving this to another method produces an error on safari
        await this.createScreenTracks();

        logger.info(
          this.localScreenAudioTrack
            ? 'Screen share started with audio track'
            : 'Screen share started without audio track',
          { operation: 'webrtc:share-screen', lesson_id: this.lessonId }
        );
      }
      const stream = await this.publishTracks();
      return { stream };
    } catch (error) {
      this.constraints.screen = false;
      return { error };
    }
  }
}
